import { render, staticRenderFns } from "./BusinessPaymentApproval.vue?vue&type=template&id=b795a7c4&scoped=true&"
import script from "./BusinessPaymentApproval.vue?vue&type=script&lang=js&"
export * from "./BusinessPaymentApproval.vue?vue&type=script&lang=js&"
import style0 from "./BusinessPaymentApproval.vue?vue&type=style&index=0&id=b795a7c4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b795a7c4",
  null
  
)

export default component.exports